
import React from 'react';
interface ICard {
  key?: number;
  svgIcon: React.ReactNode;
  title: string;
  total: string;
  paragraph: string;
  goTo?: any;
}

const TotalCard: React.FC<ICard> = ({ svgIcon, title, total, paragraph, goTo }) => {
  return (
    <div className='card-db-none' onClick={goTo}>
      <div className='card-db-header'>
        <div className='card-db-icon'>{svgIcon}</div>
        <div className='card-db-title'>{title}</div>
      </div>
      <div className='card-db-meta'>
        <span className='card-db-meta-span-info'>{total}</span>
      </div>
      <div className='card-db-actions'>
        <span className='card-db-meta-span'>{paragraph}</span>
      </div>
    </div>
  );
};
export default TotalCard;
